import { render, staticRenderFns } from "./IStarComponent.vue?vue&type=template&id=0228d31a&"
import script from "./IStarComponent.vue?vue&type=script&lang=js&"
export * from "./IStarComponent.vue?vue&type=script&lang=js&"
import style0 from "./IStarComponent.vue?vue&type=style&index=0&id=0228d31a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports